export const Link_url = {
    // url: 'http://school.cz.365mooc.cn/',
    url: 'http://www.zhxy.czvtc.edu.cn',
    
    //底部
    fooone: 'http://www.miitbeian.gov.cn/state/outPortal/loginPortal.action;jsessionid=jUpKToukN2lqWTcin0MgCMGuZHYEJXUhsSn77b7HWXhbfjbAPhNE!-2113647171',

    footwo: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34170002000066',

    foothree: 'http://bszs.conac.cn/sitename?method=show&id=0973505E8DDD6365E053022819AC8FD2'
}


// WEBPACK FOOTER //
// ./src/api/config.js